import React, { useContext } from 'react';
import BootstrapAlert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';

import AlertContext from './Alert.context';

/**
 * Alert box that can be dismissed
 *
 * Controlled via context/provider
 *
 */
function Alert() {
  const { isVisible, headerText, detailText, dismissText, variant, onDismiss } =
    useContext(AlertContext);

  return (
    <BootstrapAlert className="centered-overlay" variant={variant} show={isVisible}>
      <BootstrapAlert.Heading>{headerText.toString()}</BootstrapAlert.Heading>
      <p>{detailText.toString()}</p>
      <hr />
      <div className="d-flex justify-content-end">
        <Button onClick={onDismiss} variant={`outline-${variant}`}>
          {dismissText}
        </Button>
      </div>
    </BootstrapAlert>
  );
}

export default Alert;
